import { FormInputTypes, TypedFormInputs, GridColSpan } from 'components/form';
import { acceptImages, dropzoneValidation } from 'components/dropzone/utils';
import { SelfOnboardingProfilePhotoFormData } from 'containers/selfOnboarding/types';

export const getFormInputs = ({
  isProfilePhotoDisabled,
}: {
  isProfilePhotoDisabled: boolean;
}): TypedFormInputs<SelfOnboardingProfilePhotoFormData> => {
  return {
    file: {
      element: FormInputTypes.Dropzone,
      label: 'Profile photo',
      elementProps: {
        accept: acceptImages,
        isAvatar: true,
        disabled: isProfilePhotoDisabled,
      },
      validation: {
        required: true,
        validate: dropzoneValidation,
      },
      layout: [GridColSpan.SpanFull],
    },
  };
};

export const getDefaultValues = (
  profilePhoto: SelfOnboardingProfilePhotoFormData,
): SelfOnboardingProfilePhotoFormData => {
  const { file } = profilePhoto ?? {};

  return {
    file: file ?? null,
  };
};
